<script setup lang="ts">
import DefaqtoLogo from "@/components/general/DefaqtoLogo/DefaqtoLogo.vue";
import Incentives from "@/components/general/Incentives/Incentives.vue";
import KeyInformation from "@/components/general/KeyInformation/KeyInformation.vue";
import { useGlobalStore } from "@/stores";
const globalStore = useGlobalStore();

interface Props {
    showDefaqto?: boolean;
    showIncentive?: boolean;
}
const { showDefaqto = true, showIncentive = true } = defineProps<Props>();
</script>

<template>
    <div class="aside-key-info">
        <KeyInformation class="key-info-right" />
        <DefaqtoLogo v-if="showDefaqto" class="defaqto-right" />
        <Incentives
            v-if="globalStore.checkForIncentive && showIncentive"
            class="incentive-display"
        />
    </div>
</template>

<style scoped>
.aside-key-info {
    display: flex;
    flex-direction: column;
    padding: 1rem;
    gap: 1.5rem;
}

.defaqto-right {
    width: 90%;
    align-self: flex-start;
    margin-top: 1.2rem;
}

@media screen and (width <= 993px) {
    .incentive-display {
        display: none;
    }
}
</style>
